import { Chip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import * as S from './styles'

interface SelectableBoxProps {
	translationContext: 'bulk' | 'bulk_pact' | 'scratch'
	selected: boolean
	onSelect: () => void
	disabled?: boolean
}
const SelectableBox = ({
	translationContext,
	onSelect,
	selected,
	disabled,
}: SelectableBoxProps) => {
	const { t } = useTranslation()

	return (
		<S.Container
			$disabled={disabled}
			$selected={selected}
			onClick={disabled ? undefined : onSelect}
		>
			<S.ContainerButton>
				<Typography variant="h6" fontWeight={400}>
					{t('selectableBox.title', { context: translationContext })}
				</Typography>
			</S.ContainerButton>
			<Chip
				label={t('selectableBox.chip', { context: translationContext })}
				color="primary"
				size="small"
			/>
			<Typography variant="subtitle2" component="h5" color="textSecondary">
				{t('selectableBox.description', { context: translationContext })}
			</Typography>
		</S.Container>
	)
}

export { SelectableBox, type SelectableBoxProps }
